export default {
    main: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
    }
}